export const authRecommendation = {
  APPROVE: "approve",
  CHALLENGE: "challenge",
  DENY: "deny",
  UNKNOWN: "unknown",
};
